export const ConfigModalFooter = ({
  onSave,
  onCancel,
  isSaving,
  successMessage,
  fullScreen = false
}) => {
  if (fullScreen) {
    return (
      <div style={{
        padding: '16px 20px',
        borderTop: '1px solid #e5e7eb',
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '12px'
      }}>
        <button
          onClick={onSave}
          disabled={isSaving || successMessage}
          style={{
            padding: '10px 24px',
            fontSize: '14px',
            fontWeight: '600',
            background: successMessage ? '#16a34a' : (isSaving ? '#9ca3af' : '#3B82F6'),
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            cursor: (isSaving || successMessage) ? 'not-allowed' : 'pointer',
            transition: 'all 0.15s ease',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}
          onMouseEnter={(e) => {
            if (!isSaving && !successMessage) {
              e.currentTarget.style.background = '#2563eb';
            }
          }}
          onMouseLeave={(e) => {
            if (!isSaving && !successMessage) {
              e.currentTarget.style.background = '#3B82F6';
            }
          }}
        >
          {isSaving && (
            <div style={{
              width: '14px',
              height: '14px',
              border: '2px solid rgba(255,255,255,0.3)',
              borderTopColor: 'white',
              borderRadius: '50%',
              animation: 'spin 0.8s linear infinite'
            }} />
          )}
          {successMessage ? 'Done!' : (isSaving ? 'Saving...' : 'Get Started')}
        </button>
      </div>
    );
  }

  return (
    <div style={{
      padding: '16px 20px',
      borderTop: '1px solid #e5e7eb',
      display: 'flex',
      justifyContent: 'flex-end',
      gap: '12px'
    }}>
      <button
        onClick={onCancel}
        style={{
          padding: '8px 16px',
          fontSize: '13px',
          fontWeight: '500',
          background: 'transparent',
          color: '#6b7280',
          border: '1px solid #d1d5db',
          borderRadius: '6px',
          cursor: 'pointer',
          transition: 'all 0.15s ease'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = '#f9fafb';
          e.currentTarget.style.borderColor = '#9ca3af';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = 'transparent';
          e.currentTarget.style.borderColor = '#d1d5db';
        }}
      >
        Cancel
      </button>
      <button
        onClick={onSave}
        disabled={isSaving}
        style={{
          padding: '8px 16px',
          fontSize: '13px',
          fontWeight: '600',
          background: isSaving ? '#9ca3af' : '#3B82F6',
          color: 'white',
          border: 'none',
          borderRadius: '6px',
          cursor: isSaving ? 'not-allowed' : 'pointer',
          transition: 'all 0.15s ease',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}
        onMouseEnter={(e) => {
          if (!isSaving) {
            e.currentTarget.style.background = '#2563eb';
          }
        }}
        onMouseLeave={(e) => {
          if (!isSaving) {
            e.currentTarget.style.background = '#3B82F6';
          }
        }}
      >
        {isSaving && (
          <div style={{
            width: '14px',
            height: '14px',
            border: '2px solid rgba(255,255,255,0.3)',
            borderTopColor: 'white',
            borderRadius: '50%',
            animation: 'spin 0.8s linear infinite'
          }} />
        )}
        {isSaving ? 'Saving...' : 'Save'}
      </button>
    </div>
  );
};
